export enum QueryOperators {
    in = "$in",
    nin = "$nin",
    ne = "$ne",
    contains = "$contains",
    containsAny = "$containsAny",
    and = "$and",
    or = "$or",
    exists = "$exists",
    inQuery = "$inQuery",
    eq = "$eq",
    gte = "$gte"
    //@todo enumerate the rest
}
